import React from 'react';

import { useViewType, ViewType } from '@eika/hooks';

import { useConfig } from '../../../defaultConfig';
import { useAccountFreeWithdrawals, useAccounts } from '../../../fetchHooks/useAccount';
import { useTransferAccountsContext } from '../../../hooks/useAccountState';
import { useFormContext } from '../../../hooks/useForm';
import { useSigningContext } from '../../../signingContext/signingContext';
import { FieldProps, RecurringTransferDesktopFields, RecurringTransferMobileFields } from './fields';
import { RecurringTransferAction } from './form/actions';
import { RecurringTransferState } from './form/state';
import { RecurringTransferError } from './form/validate';

interface Props {
    locked?: boolean;
    shouldFocusFirstElement?: boolean;
}

const RecurringTransferFields: React.FC<Props> = ({ locked = false, shouldFocusFirstElement = false }) => {
    const { featureToggles } = useConfig();
    const form = useFormContext<RecurringTransferState, RecurringTransferAction, RecurringTransferError>();
    const { signingOperationPending } = useSigningContext();

    const { data: accounts, ...accountState } = useAccounts();
    const { targetFromAccount } = useTransferAccountsContext();
    const { data: freeWithdrawals, showFreewithdrawal } = useAccountFreeWithdrawals(
        targetFromAccount,
        featureToggles.enableGettingAccountWithdrawalsInPayment,
    );

    const viewType = useViewType();
    const isMobile = viewType === ViewType.mobile;

    const lockToAccount = !!new URLSearchParams(window.location.search).get('locktoaccount');
    const fieldProps: FieldProps = {
        form,
        signingOperationPending,
        locked,
        lockToAccount,
        shouldFocusFirstElement,
        freeWithdrawals: {
            show: showFreewithdrawal,
            data: freeWithdrawals,
        },
        accounts,
        accountState,
    };

    return isMobile ? (
        <RecurringTransferMobileFields {...fieldProps} />
    ) : (
        <RecurringTransferDesktopFields {...fieldProps} />
    );
};

export default RecurringTransferFields;
